"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var OperatorSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(OperatorSelect, _PureComponent);

  function OperatorSelect() {
    (0, _classCallCheck2.default)(this, OperatorSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(OperatorSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(OperatorSelect, [{
    key: "handleChange",
    value: function handleChange(value) {
      return this.props.onChange(value.target.value);
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "AudienceTargeting.operator." + suffix;
    }
  }, {
    key: "getValueOrDefault",
    value: function getValueOrDefault(value) {
      var options = this.props.options;
      return options.includes(value) ? value : options[0];
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this = this;

      var _this$props = this.props,
          labelConfig = _this$props.labelConfig,
          options = _this$props.options,
          disabledOptions = _this$props.disabledOptions;
      return options.map(function (option) {
        var customText;

        if (labelConfig.operator) {
          customText = labelConfig.operator[option];
        }

        return {
          text: customText || _I18n.default.text(_this.getLangKey(option)),
          value: option,
          disabled: disabledOptions.indexOf(option) > -1
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var value = this.props.value;
      return _react.default.createElement(_UISelect.default, {
        className: "targeting-option__select-rule short content",
        value: this.getValueOrDefault(value),
        onChange: function onChange(val) {
          return _this2.handleChange(val);
        },
        options: this.getOptions()
      });
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        value: _react.PropTypes.string.isRequired,
        options: _react.PropTypes.array,
        disabledOptions: _react.PropTypes.array,
        labelConfig: _react.PropTypes.object,
        onChange: _react.PropTypes.func
      };
    }
  }]);
  return OperatorSelect;
}(_react.PureComponent);

exports.default = OperatorSelect;
module.exports = exports.default;